/**
 * Sculpt brand blob shapes (A-G), hosted as Webflow assets, all authored on a
 * 0 0 1000 1000 viewBox. Used as runtime CSS masks so avatar photos can be
 * uploaded as plain squares — no per-photo postproduction.
 */
const CDN = "https://cdn.prod.website-files.com/67fd68910536fe52a2d9e022";

export const SCULPT_SHAPES = [
  `${CDN}/6a59524a4ee1ff889da2a321_A.svg`,
  `${CDN}/6a59524a59043787d914300d_B.svg`,
  `${CDN}/6a59524a1948a16c182a37f1_C.svg`,
  `${CDN}/6a59524a84a54543efa5a59d_D.svg`,
  `${CDN}/6a59524adc2bea28f30846bc_E.svg`,
  `${CDN}/6a59524a1d383c05eb3cce9c_F.svg`,
  `${CDN}/6a59524afb61855fc6e7686f_G.svg`,
];

/** CSS mask-image value for shape `index` (wraps past the end). */
export function sculptShapeMask(index: number) {
  return `url("${SCULPT_SHAPES[index % SCULPT_SHAPES.length]}")`;
}

/** Warm the browser cache so masks apply without a flash of unmasked images. */
export function preloadSculptShapes() {
  SCULPT_SHAPES.forEach((src) => {
    const img = new Image();
    img.src = src;
  });
}
